module.exports = __webpack_public_path__ + "img/txp2.01fe165b.jpg";